import { RULE_SCHEMA } from '../data/ruleSchema';
import { RULE_PRESETS } from '../data/lotteryData';
import type { RuleId } from '../data/ruleSchema';
import type { TicketRule } from '../types/rules';

export const SIMPLE_VIBE_IDS = ['hot', 'overdue', 'balanced'] as const;
export type SimpleVibeId = (typeof SIMPLE_VIBE_IDS)[number];

function ticketRule(
  id: RuleId,
  settings: Record<string, string | number | boolean>,
  instanceId: string
): TicketRule {
  const preset = RULE_PRESETS.find((p) => p.id === id);
  if (!preset) {
    throw new Error(`simpleVibeStacks: missing preset for rule ${id}`);
  }
  return {
    instanceId,
    id,
    name: preset.name,
    presetIcon: preset.icon,
    weight: 10,
    enabled: true,
    settings: { ...RULE_SCHEMA[id].defaults, ...settings },
  };
}

/**
 * Ephemeral stacks for Smart pick (simple mode). Not persisted — POSTed to rules stats API only.
 */
export function ticketRulesForSimpleVibe(vibe: SimpleVibeId): TicketRule[] {
  switch (vibe) {
    case 'hot':
      return [ticketRule('hot', { window: 180, topK: 12, minHot: 3 }, 'simple-hot-hot')];
    case 'overdue':
      return [ticketRule('overdue', { threshold: 25, minOverdue: 2 }, 'simple-overdue-overdue')];
    case 'balanced':
      return [
        ticketRule('spread', { zones: 5, strictness: 'medium' }, 'simple-balanced-spread'),
        ticketRule('hot', { window: 180, topK: 8, minHot: 1 }, 'simple-balanced-hot'),
        ticketRule('cold', { window: 180, bottomK: 8, minCold: 1 }, 'simple-balanced-cold'),
      ];
    default: {
      const _exhaustive: never = vibe;
      return _exhaustive;
    }
  }
}
